module.exports = __webpack_public_path__ + "img/ico-calendar.46d98c6f.svg";